import { ReactComponent as IconChevron } from '@/assets/svgs/profile-chevron.svg'

const Select = ({ children, containerProps, selectProps }) => {

	return (
		<div className="select" {...containerProps} >
			<div className="select__icon"><IconChevron /></div>
			<div className="select__options">
				<select {...selectProps}>
					{children}
				</select>
			</div>
		</div>
	)
}

export default Select
